const MESSAGE = {
    SENT_TO_OMC: {
        success: "Documentul a fost trimis in OMC!",
        successTitle:"Document trimis!",
        error: "Eroare trimitere în OMC:",
        longError: "A apărut o eroare la trimiterea documentului."
    },
    APPROVE: {
        success: "Documentul a fost aprobat!",
        successTitle:"Document aprobat!",
        error: "Eroare la aprobare:",   
        longError: "A apărut o eroare la aprobarea documentului."
    },
    PROCESS: {
        success: "Documentul a fost procesat!",
        error: 'Eroare la procesare:'
    },
    ACTUALIZARE: {
        success: "Documentul a fost actualizat cu succes!"
    },
    SUPPORTING_DOCUMENTS_ERRORS:{
        get: "Eroare la preluarea documentelor:",
        upload:"Eroare la încărcarea documentelor:",
        downloadDocuments: "Eroare la descărcarea documentului:",
        downloadZip: "Eroare la descarcarea zip:",
        delete: "Eroare la ștergerea documentului:",
    },
    FILE_SIZE_ERROR: {
        title: "Fișiere prea mari",
        description: "Dimensiunea totală a fișierelor selectate depășește 10MB."
    },
    PDF_EXPORT: {
        error: "Eroare la preluare PDF"
    },
    EXCEL_EXPORT: {
        error: "Eroare la export documente",
    },
    XML_EXPORT : {
        error: "Eroare la descărcare XML"
    },
    RULES: {
        errorFetch: "Eroare in timpul preluarii datelor",
        addRuleSuccess:"Regula adaugata cu succes!",
        addRuleError:"Eroare la adaugarea regulii.",
        deleteRuleSuccess:"Regula a fost stearsă cu succes!",
        deleteRuleError: "Eroare la stergerea regulii.",
        ruleUpdateSuccess: "Regula actualizata cu succes!",
        updateRuleError: "Eroare la actualizarea regulii",
        updateRuleSuccess: "Regula actualizată cu success!"
    },
    FILTER_LOADING_ERROR: {
        label: "Eroare la încărcarea datelor în filtru:"
    },
    EXCEL: {
        success: "Fișierul excel a fost importat cu succes!",
        error_data: "Datele nu au fost găsite în fișier",
        error_read: "Eroare la importarea fișierului Excel"
        
    },
    POINT_OF_WORKS: {
        error: "Eroare la extragerea punctelor de lucru",
    },
    GENERIC_ERROR: {
        title: "Eroare formular:",
        description: "Există erori în formular. Vă rugăm să verificați câmpurile.",
    },
    LOCAL_STORAGE_ERROR: {
        error:"Eroare la stocare locala",
    },
    ERROR: {
        label:"Eroare"
    },
    ORGANISATION_ERROR: {
        label: "A apărut o eroare la încărcarea organizațiilor.",
        console: "Eroare la încărcarea organizațiilor:"
    },
    SPV_ERROR: {
        label: "Eroare la încărcarea ultimelor sincronizări SPV:",
    },
    STATUS_LOADING_ERROR: {
        label: "Eroare la încărcarea statuturilor:"
    },
    SUCCESS: {
        label: "Succes"
    },
    PROCESS_ERROR: {
        label: "A apărut o eroare la procesarea documentului. Încercați din u."
    },
    UPDATE_ERROR: {
        label: "A apărut o eroare la actualizarea documentului. Încercați din nou."
    },
    MANDATORY_FIELD: {
        label: 'Acest câmp este obligatoriu'
    },
    MAX_NUMBER_CHARACTERS: {
        label: (size) => `Campul permite maxim ${size} de caractere`
    },
    NON_NULL_QUANTITIY: {
        label: 'Cantitatea trebuie să fie diferita de 0'
    },
    NOT_NEGATIVE_PRICE: {
        label: 'Prețul nu poate fi negativ'
    },
    AT_LEAST_ONE_LINE: {
        label: 'Adăugați cel puțin o linie de document'
    },
    PRICE_DIFFERENCE_ERRORS: {
        title: 'Diferențe detectate',
        description: 'S-a detectat o neconcordanta intre valorile preluate automat din SPV si cele procesate in platforma.',
        button: 'OK'
    },
    NO_ELEMENT_FOUND: {
        label: "Niciun element gasit."
    },
    OMC_GENERIC_ERROR: {
        label: "A aparut o problema la trimiterea la OMC"
    }
}

export default MESSAGE;
